import React, { useState } from "react";
import { Card, Input, Button, Alert } from "antd";
import { Link } from "react-router-dom";
import MainLayout from "../../components/layout";
import { ArrowLeftOutlined } from "@ant-design/icons";

const ForgotPasswordPage = () => {
  const { http } = global.services;

  const [email, setEmail] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const submit = async () => {
    setSubmitted(true);

    if (!email) {
      return setErrors({ message: ["The email address field is required."] });
    }

    let error = "";
    try {
      let { data } = await http.post("forgot-password", {
        email: email.trim().toLowerCase(),
      });
      if (data.error) {
        error = { message: ["The email address does not exist."] };
      }
      setEmail(null);
      setSuccess(true);
      setSubmitted(false);
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch (err) {
      const { data, status } = err.response;
      if (status === 400) {
        error = { message: [data.error] };
      }
      setSubmitted(false);
    }

    setErrors(error || {});
  };

  return (
    <React.Fragment>
      <MainLayout>
        <div className="flex justify-center items-center">
          <Card bordered={false}>
            <div className="flex-column items-center" style={{ padding: 40 }}>
              <strong>
                <h1 style={{ fontSize: 25, fontWeight: 550, marginBottom: 3 }}>
                  Forgot Password
                </h1>
              </strong>
              <p
                style={{
                  opacity: 0.7,
                  marginBottom: 20,
                  width: 300,
                  textAlign: "center",
                }}
              >
                Don’t worry, we’ll email you a link to reset your password.
              </p>
              {success && (
                <>
                  <Alert
                    message="Email sent successfully"
                    style={{ width: "100%", textAlign: "center" }}
                    type="success"
                  />
                  <br />
                </>
              )}
              {errors.message && (
                <>
                  <Alert
                    message={errors.message[0]}
                    style={{ width: "100%", textAlign: "center" }}
                    type="error"
                  />
                  <br />
                </>
              )}
              <div className="flex flex-column flex-grow" style={{ width: 300 }}>
                <span>Email address</span>
                <Input
                  value={email}
                  className="inputs"
                  placeholder=""
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <br />
              <Button
                type="primary"
                block
                style={{
                  color: "#fff",
                  borderColor: "#c6b4f3",
                  backgroundColor: "#c6b4f3",
                  borderRadius: 8,
                  height: 38,
                }}
                onClick={submit}
                loading={submitted}
              >
                Send Reset Link
              </Button>
              <Link to="/" className="auth-back-btn">
                <ArrowLeftOutlined /> Back to Login
              </Link>
            </div>
          </Card>
        </div>
      </MainLayout>
    </React.Fragment>
  );
};

export default ForgotPasswordPage;
